type ActionWithParams<T> = (machine: unknown, params: T) => void;

export const createRequiredAction = <TPayload>(
  actionName: string,
): ActionWithParams<TPayload> => {
  return (_machine, _params) => {
    // It is intended that this action should throw if not overridden via .provide
    throw new Error(
      `Action '${actionName}' is required but not implemented. Ensure that it is provided via .provide() when instantiating the parent machine.`,
    );
  };
};
